import React, { useEffect, useState } from "react";
import SimpleDialog from "../../../../../../Dialogs/SimpleDialog";
import { PersonPinCircleOutlined } from "@material-ui/icons";
import { Container } from "@mui/material";
import { useCM05Form } from "../../hooks/useCM05Form";
import AvisoNoHayConvenio from "./AvisoNoHayConvenio";
import moment from "moment";
import * as api from "../../api";
import { UrlApi } from "../../../../../../../services/apirest";
import Cm05Form from "./Cm05Form";
import DialogConfirmarEliminar from "./DialogoConfirmarEliminar";
import Notify from "../../../../../../Notify";

export default function CM05FormContainer({
    open,
    setOpen,
    cliente,
    configConvenio
}) {
    const clienteCuit = cliente?.cuit?.trim();
    const [cicloAGuardar, setCicloAGuardar] = useState();
    const [IIBBPadrones, setIIBBPadrones] = useState();
    const [notify, setNotify] = useState({ open: false, mensaje: "", severity: "", color: "" });

    const {
        inscrIIBB,
        grabarEIniciarIIBB,
        addImpuesto,
        handleInputChange,
        iniciarFormulario,
        handleInputChangeProvincia,
        armarPayload,
        removeImpuesto,
    } = useCM05Form();

    const icono = <PersonPinCircleOutlined />

    const handleClose = () => {
        setOpen(false)
    }

    useEffect(() => {
        iniciarFormulario(clienteCuit)
        api.getRegPadrones(clienteCuit, setIIBBPadrones)
        configConvenio && configConvenio.inscripcion_vence !== "0" ? api.getDatosProximoCiclo(setCicloAGuardar) : setCicloAGuardar({id_ciclo:0})
    }, [])

    useEffect(() => {
        if (cicloAGuardar?.id_ciclo >= 0) {
            api.getInscripcionesCiclo(clienteCuit, cicloAGuardar.id_ciclo, grabarEIniciarIIBB, Number(configConvenio.max_inscripciones), null, IIBBPadrones)
        }
    }, [cicloAGuardar])

    const [openEliminar, setOpenEliminar]=useState();
    
    const [inscripcionSeleccionada, setInscripcionSeleccionada]=useState();

    const handleClickDelBtn = (field, index) => {
        setOpenEliminar(true)
        setInscripcionSeleccionada({...field, index:index})
    }

    const eliminar = async (idInscripcion, index, idProvincia) => {
    if (!idInscripcion) return;

    try {
        await api.deleteInscripcion(idInscripcion,clienteCuit, idProvincia);
        
        if (index === 0) {
            iniciarFormulario(clienteCuit);
        }

        setOpenEliminar(false)
        api.getInscripcionesCiclo(
            clienteCuit,
            cicloAGuardar.id_ciclo,
            grabarEIniciarIIBB,
            Number(configConvenio.max_inscripciones)
        );

    } catch (error) {
        alert("No se pudo eliminar la inscripcion!");
        console.error("Error al eliminar la inscripción:", error);
        
        api.getInscripcionesCiclo(
            clienteCuit, 
            cicloAGuardar.id_ciclo, 
            grabarEIniciarIIBB, 
            Number(configConvenio.max_inscripciones)
        );
    }
};

    const guardar = async (inscripcion) => {
        const payload = {
            id_provincia: inscripcion.id_provincia,
            cuit: cliente.cuit.trim(),
            percepcion: inscripcion.percepcion || 0,
            coeficiente_unificado: inscripcion.coeficiente_unificado,
            cuit_limpio: cliente.cuit.trim().replace(/\D/g, ""),
            id_ciclo_fiscal: cicloAGuardar.id_ciclo,
            user:localStorage.getItem("user") 
        }

        const res = await fetch(UrlApi + "/iibb_clientes/simple", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });

        if (res.ok) {
            setNotify({
                open:true,
                severity:"success",
                mensaje:"Inscripción guardada con éxito.",
                color:"#D4EFDF"
            })
            api.getInscripcionesCiclo(clienteCuit, cicloAGuardar.id_ciclo, grabarEIniciarIIBB, Number(configConvenio.max_inscripciones))
        } else {
            alert("No se pudieron guardar los datos.")
            api.getInscripcionesCiclo(clienteCuit, cicloAGuardar.id_ciclo, grabarEIniciarIIBB, Number(configConvenio.max_inscripciones))
        }
    }

    const editar = async (field) => {
        const payload = {
            percepcion: field.percepcion,
            coeficiente_unificado: field.coeficiente_unificado,
            user:localStorage.getItem("user"),
            idProvincia:field.id_provincia,
            cuit:field.cuit
        }
        try {
            const Url = UrlApi + "/iibb_clientes/" + field.id_inscripcion;
            const response = await fetch(Url, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });
            if(response.ok){
                setNotify({
                    open: true,
                    severity: "success",
                    mensaje: "Inscripción modificada con éxito.",
                    color: "#D4EFDF"
                })
                api.getInscripcionesCiclo(clienteCuit, cicloAGuardar.id_ciclo, grabarEIniciarIIBB, Number(configConvenio.max_inscripciones))
            }
        } catch (error) {
            console.error("Error al editar la inscripción:", error);
        }
    }

    const childrenProps = {
        inscrIIBB,
        addImpuesto,
        handleInputChange,
        handleInputChangeProvincia,
        armarPayload,
        IIBBPadrones,
        handleClose,
        handleClickDelBtn,
        guardarInscripcion: guardar,
        editarInscripcion: editar,
        maxRows:Number(configConvenio.max_inscripciones),
        notify,
        setNotify
    }

    const children = (
        <div>
            <Container maxWidth="xl" sx={{ p: 2 }}>
                {Object.keys(configConvenio).length > 0 ? (
                    <Cm05Form {...childrenProps} />
                ) : (
                    <AvisoNoHayConvenio />
                )}
                
            </Container>
        </div>
    );

    // useEffect(()=>{
    //     const coeficiente = inscrIIBB.reduce((acum, valorActual)=>{
    //         let value = valorActual.coeficiente_unificado
    //         console.log("VALUE: ",  value)
    //         // return acum += valorActual.coeficiente_unificado
    //     })
    //     console.log(coeficiente)
    // },[inscrIIBB])

    return (
        <div>
            <SimpleDialog
                titulo="Carga certificado CM05"
                open={open}
                onClose={handleClose}
                width={"xl"}
                icono={icono}
                subtitulo={cicloAGuardar?.desde ? `Período: ${moment(cicloAGuardar.desde).format("DD/MM/YYYY")} - ${moment(cicloAGuardar.hasta).format("DD/MM/YYYY")} ` : ``}
            >
                {children}
            </SimpleDialog>
            <DialogConfirmarEliminar
                open={openEliminar}
                onClose={() => setOpenEliminar(false)}
                onConfirm={() => eliminar(inscripcionSeleccionada.id_inscripcion, inscripcionSeleccionada.index, inscripcionSeleccionada.id_provincia)}
                loading={false}
            />
            {notify?.open && (
                <Notify
                    open={notify.open}
                    severity={notify.severity}
                    mensaje={notify.mensaje}
                    color={notify.color}
                    handleClose={() => setNotify({open: false })}
                />
            )}

        </div>
    );
}
